module.exports = __webpack_public_path__ + "img/work.b775692d.png";